import * as React from 'react';
import { VotingProps } from 'client/respondent/core/types';
import { SurveySharedInner } from '../survey-shared';

export const ClosedSurvey: React.FC<VotingProps.SurveyClosed> = (props) => {
  return <SurveySharedInner {...props} errorsByQuestionId={{}} />;
};
